import { withDefaults } from '@warp-drive/legacy/model/migration-support';

// API resource: tio-api app/resources/api/v1/pcs_program_setting_resource.rb
// Registered from the systemic missing-schema audit (the #9130/#8988 class:
// an API-emittable JSON:API type the FE manifest never registered).
// enum/subject/predicate/value inherited from EnumSettingResource. inverse:null
// because the registered pcs-program.schema.ts does not declare a reciprocal
// pcsProgramSettings hasMany (set it only if that hasMany is added there too).
const PcsProgramSettingSchema = withDefaults({
  type: 'pcs-program-setting',
  fields: [
    { kind: 'attribute', name: 'enum' },
    { kind: 'attribute', name: 'subject' },
    { kind: 'attribute', name: 'predicate' },
    { kind: 'attribute', name: 'value' },
    {
      kind: 'belongsTo',
      name: 'pcsProgram',
      type: 'pcs-program',
      options: { async: false, inverse: null },
    },
  ],
});

export default PcsProgramSettingSchema;
